import React from 'react';

export const VognText = () => {
  return (
    <p>
      Розміщують у легкодоступних і помітних місцях — коридорах, біля входів або виходів із приміщень тощо, а також у
      пожежонебезпечних місцях так, щоб не створювати перешкод для евакуації.
    </p>
  );
};
